module.exports = __webpack_public_path__ + "img/part3-icon1.d40bfc4c.png";